import React, {useEffect} from 'react';
import {Button} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {AlertModal} from 'presentation/components/AlertModal';
import {AttachmentInstructionsModalProps} from './types';

const {
	modal: {authorizationAttachmentInstruction},
} = translations['pt-br'].others.uploadFiles;

const {notice, understood} = translations['pt-br'].commons;

export const AttachmentInstructionsModal = ({
	open,
	setOpen,
	fileInputRef,
	alreadyChecked,
	setChecked,
	isOpenedByDragAndDrop,
	headerModalDataTagId,
	closeModalDataTagId,
	confirmModalDataTagId,
}: AttachmentInstructionsModalProps) => {
	const shouldOpenFileInputAutomatically = !open && alreadyChecked && !isOpenedByDragAndDrop;

	const handleCheckInstructions = () => {
		setChecked(true);
		setOpen(false);
	};

	const handleOnClose = () => {
		handleCheckInstructions();
	};

	useEffect(() => {
		if (fileInputRef.current && shouldOpenFileInputAutomatically) {
			fileInputRef.current.click();
		}
	}, [open, alreadyChecked]);

	return (
		<AlertModal
			headerDataTagId={headerModalDataTagId}
			closeBtnDataTagId={closeModalDataTagId}
			open={open}
			onClose={handleOnClose}
			description={authorizationAttachmentInstruction.description}
			title={authorizationAttachmentInstruction.title}
			headerTitle={notice}
			variant="info"
			footerContent={
				<Button
					data-tag-id={confirmModalDataTagId}
					variant="contained"
					size="large"
					fullWidth
					onClick={handleCheckInstructions}>
					{understood}
				</Button>
			}
		/>
	);
};
